export const proposalImageClass =
    "flex min-h-40 max-h-40 min-w-[58px] max-w-[58px] object-cover md:min-h-[51px] md:max-h-[51px] md:min-w-[68px] md:max-w-[68px]";
